module.exports = __webpack_public_path__ + "static/media/window1.43efa06e.png";